import MetaNavigation from './meta_navigation';

class PageFooter {
    constructor(pagefooterBlockSelector = '.page-footer') {
        this.pagefooterBlockSelector = pagefooterBlockSelector;
        this.setElements($(pagefooterBlockSelector))
            .initComponents()
            .registerEvents();
    }

    setElements($container) {
        this.elements = {
            $container,
            tyreNavLists: $container.find(this.pagefooterBlockSelector + '__tyre-navigation .multi-lvl-content-nav__lvl1-item'),
            metaNav: $container.find(this.pagefooterBlockSelector + '__meta-navigation')
        };
        return this;
    }

    initComponents() {
        new MetaNavigation(this.elements.metaNav);

        return this;
    }

    registerEvents() {
        $(window).on('resize', this._onWindowResize.bind(this));
        this._onWindowResize();

        return this;
    }

    _onWindowResize() {
        this.elements.tyreNavLists.eqHeight();
    }
}

export default PageFooter;